export default __webpack_public_path__ + "static/media/yellowshiny.e17c4f4b.svg";